const store = {
    namespaced: true,
    state: {
        isMenuMobileVisible: false,
        isModalEmailVisible: false,
        isModalUserVisible: false,
        isMarkdownSplitVisible: false,
        isMarkdownPreviewVisible: false,
        isMenuUploadVisible: false,
        menuUploadType: "link"
    },
    mutations: {

        /**
         * Show menu for mobile.
         *
         * @param {Object} state The store's state.
         */
        showMenuMobile: function(state) {
            state.isMenuMobileVisible = true;
        },

        /**
         * Hide menu for mobile.
         *
         * @param {Object} state The store's state.
         */
        hideMenuMobile: function(state) {
            state.isMenuMobileVisible = false;
        },

        /**
         * Show modal email.
         *
         * @param {Object} state The store's state.
         */
        showModalEmail: function(state) {
            state.isModalEmailVisible = true;
        },

        /**
         * Hide modal email.
         *
         * @param {Object} state The store's state.
         */
        hideModalEmail: function(state) {
            state.isModalEmailVisible = false;
        },

        /**
         * Hide modal user.
         *
         * @param {Object} state The store's state.
         */
        hideModalUser: function(state) {
            state.isModalUserVisible = false;
        },

        /**
         * Show modal user.
         *
         * @param {Object} state The store's state.
         */
        showModalUser: function(state) {
            state.isModalUserVisible = true;
        },

        /**
         * Toggle markdown split.
         *
         * @param {Object} state The store's state.
         */
        toggleMarkdownSplit: function(state) {
            state.isMarkdownSplitVisible = !state.isMarkdownSplitVisible;
        },

        /**
         * Toggle markdown preview.
         *
         * @param {Object} state The store's state.
         */
        toggleMarkdownPreview: function(state) {
            state.isMarkdownPreviewVisible = !state.isMarkdownPreviewVisible;
        },

        /**
         * Show the menu upload.
         *
         * @param {Object} state The store's state.
         * @param {String} type The upload type (image or link).
         */
        showMenuUpload: function(state, type) {
            state.isMenuUploadVisible = true;
            state.menuUploadType = type;
        },

        /**
         * Hide the menu upload.
         *
         * @param {Object} state The store's state.
         */
        hideMenuUpload: function(state) {
            state.isMenuUploadVisible = false;
        }
        
    }
};

export default store;